import MuiContainer from "./MuiContainer";
import MuiButton from "./MuiButton";
import MuiInputLabel from "./MuiInputLabel";
import { Components, Theme } from "@mui/material";
interface PropsColorOverrides {
  disabled: true; // Thêm color "disabled" vào type của color
  light: true; // Thêm color "light" vào type của color
  dark: true; // Thêm color "light" vào type của color
  normal: true; // Thêm color "light" vào type của color
  darkgreen: true;
}
declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides extends PropsColorOverrides {}

  interface ButtonPropsVariantOverrides {}
  interface ButtonPropsSizeOverrides {
    xlarge: true;
    xxlarge: true;
  }
}
declare module "@mui/material/CircularProgress" {
  interface CircularProgressPropsColorOverrides extends PropsColorOverrides {}
}
declare module "@mui/material/SvgIcon" {
  interface SvgIconPropsColorOverrides extends PropsColorOverrides {}
}
const components: Components<Omit<Theme, "components">> = {
  MuiContainer,
  MuiButton,
  MuiInputLabel,
};

export default components;
